import { useField } from 'formik';

type MyRadioProps = {
	name: string;
	value: number | string;
	label: string;
	disabled?: boolean;
	className?: string;
};

const MyRadio = ({ label, className = '', ...props }: MyRadioProps) => {
	const [field] = useField({
		name: props.name,
		type: 'radio',
		value: String(props.value),
	});

	return (
		<label
			className={`app-radio ${props.disabled ? 'is-disabled' : ''} ${className}`}
		>
			<input
				{...field}
				type='radio'
				value={String(props.value)}
				disabled={props.disabled}
			/>
			<span className='app-radio__dot' aria-hidden='true' />
			<span className='app-radio__text'>{label}</span>
		</label>
	);
};

export const MyFieldError = ({ name }: { name: string }) => {
	const [, meta] = useField(name);
	return meta.touched && meta.error ? (
		<div className='text-danger mt-1'>{meta.error}</div>
	) : null;
};

export default MyRadio;
